import { FC, memo, useRef } from 'react'
import { Flex, Typography } from 'antd'
import { TaskLogs } from '../TaskCard/ui/TaskLogs'
import { TaskItem } from '@/entities/task/model/taskTypes'
import { getStatusTag } from '../../lib/getStatusTag'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Content, LogsDataModal } from './styled'
import { useBreakpoint } from '@/app/hooks/useBreakpoint'

interface LogsModalProps {
  visible: boolean
  taskId: string
  taskNumber: number
  taskStatus: TaskItem['status'] | ''
  onClose: () => void
}

export const LogsModal: FC<LogsModalProps> = memo(
  ({ visible, taskId, taskNumber, taskStatus, onClose }) => {
    const modalContentRef = useRef<HTMLDivElement>(null)
    const { isSm, isXs } = useBreakpoint()
    const isMobile = isXs || isSm

    return (
      <LogsDataModal
        centered
        open={visible}
        onCancel={onClose}
        footer={null}
        width={1280}
        destroyOnHidden
        closeIcon={
          <Icon
            name={isMobile ? 'closed_modal_phone' : 'closed_modal'}
            size={16}
          />
        }
        title={
          !isMobile ? (
            <Flex align="center" gap={24}>
              <Typography.Title level={2}>
                Задача №{taskNumber}
              </Typography.Title>
              {taskStatus && getStatusTag(taskStatus)}
            </Flex>
          ) : (
            'Логи выполнения'
          )
        }
      >
        <Content vertical ref={modalContentRef}>
          <TaskLogs
            taskId={taskId}
            taskNumber={taskNumber}
            taskStatus={taskStatus}
          />
        </Content>
      </LogsDataModal>
    )
  }
)
